import { render, staticRenderFns } from "./DropItextPop.vue?vue&type=template&id=0872c664"
import script from "./DropItextPop.vue?vue&type=script&lang=js"
export * from "./DropItextPop.vue?vue&type=script&lang=js"
import style0 from "./DropItextPop.vue?vue&type=style&index=0&id=0872c664&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0872c664')) {
      api.createRecord('0872c664', component.options)
    } else {
      api.reload('0872c664', component.options)
    }
    module.hot.accept("./DropItextPop.vue?vue&type=template&id=0872c664", function () {
      api.rerender('0872c664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/DropItextPop.vue"
export default component.exports